// PupilBehavior.js
import { useTranslation } from 'react-i18next';
import LogoOjo from '../../../icons/logo-ojo';
// import Pupil from '../../../icons/pupil';
import OptimizedLensImage from '../../../img/optimized_lens_small.jpg';
import StandartLensImage from '../../../img/standard-lens_small.jpg';

import { Slider } from 'primereact/slider';

const PupilBehavior = ({ data }) => {
    const { t } = useTranslation();

    // Read pupil sizes from data
    const rightPupilSize = data?.processed_data?.pupil_diameter_mm?.right;
    const leftPupilSize = data?.processed_data?.pupil_diameter_mm?.left;

    // Define thresholds
    const threshold_large = 4.5; // value for large pupil diameter in mm
    const threshold_small = 3; // value for small pupil diameter in mm

    // Determine if pupils are large, small, or asymmetric
    const isLarge = (rightPupilSize > threshold_large || leftPupilSize > threshold_large);
    const isSmall = (rightPupilSize < threshold_small && leftPupilSize < threshold_small);

    // Construct the pupil text key
    let pupilTextKey = 'pupil.text.average';
    if (isLarge) {
        pupilTextKey = 'pupil.text.large';
    } else if (isSmall) {
        pupilTextKey = 'pupil.text.small';
    }

    // Construct the pupil text key
    let pupilTitleKey = 'pupil.title.average';
    if (isLarge) {
        pupilTitleKey = 'pupil.title.large';
    } else if (isSmall) {
        pupilTitleKey = 'pupil.title.small';
    }

    let minPupilValue = 1.5;
    let maxPupilValue = 7;
    const calculatePupilFactor = ( left, right) => {
        let average = (left + right) /2;
        average = Math.max(minPupilValue, Math.min(average, maxPupilValue)); // confine the value to the interval [minPupilValue,maxPupilValue]
        return average;
    }

    return (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-3 px-3 sm:px-6">
            <div>
                <div className="border border-white py-3 px-4 rounded-md">
                    <div className="text-center uppercase text-white text-xs font-bold pb-2">{t('pupilFactor')}</div>
                    <Slider
                        value={calculatePupilFactor(rightPupilSize,leftPupilSize)}
                        className="mimetika-slider slider w-full"
                        min={minPupilValue}
                        max={maxPupilValue}
                    />

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3 px-6">
                        {/* Right Eye */}
                        <div className="m-auto">
                            <div className="text-xs uppercase text-white font-semibold mb-2">{t('right')}</div>
                            <div className="relative">
                                <LogoOjo style={{ maxHeight: '80px' }} />
                                <div className="iris-eye absolute">
                                </div>
                            </div>
                            <div className="text-white mt-3 text-xxs">
                                <div className="mb-1">
                                    <strong className="uppercase">{t('pupilDiameter')}: </strong>
                                    {rightPupilSize != null ? rightPupilSize.toFixed(2) : t('N/A')}
                                    {t('mm')}
                                </div>
                            </div>
                        </div>
                        {/* Left Eye */}
                        <div className="m-auto">
                            <div className="text-xs uppercase text-white font-semibold mb-2">{t('left')}</div>
                            <div className="relative">
                                <LogoOjo />
                                <div className="iris-eye absolute">
                                </div>
                            </div>
                            <div className="text-white mt-3 text-xxs">
                                <div className="mb-1">
                                    <strong className="uppercase">{t('pupilDiameter')}: </strong>
                                    {leftPupilSize != null ? leftPupilSize.toFixed(2) : t('N/A')}
                                    {t('mm')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border border-white py-3 px-4 rounded-md mt-5">
                    <div className="text-sm text-left text-white font-semibold mb-3">{ t(pupilTitleKey) }</div>
                    <textarea
                        rows={5}
                        readOnly={true}
                        className="w-full border-white border-grey-ligth border text-sm rounded-md py-2 px-2"
                        value={t(pupilTextKey)}
                    />
                </div>
                </div>
            <div className="border border-white py-3 px-4 lg:px-4 rounded-md">
                <div className="">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 m-0 pb-3">
                        <div>
                            <div className="text-center text-white text-sm font-bold pb-3">{t('standardLens')}</div>
                            <img className="m-auto rounded-md object-contain rounded" style={{ }} src={StandartLensImage} />
                        </div>
                        <div>
                            <div className="text-center text-white text-sm font-bold pb-3">{t('withPupilarFactor')}</div>
                            <img className="m-auto rounded-md object-contain rounded" style={{   }} src={OptimizedLensImage} />
                        </div>
                    </div>
                    <div className="pt-4">
                        <textarea
                            rows={5}
                            readOnly={true}
                            className="w-full border-grey-ligth border text-sm rounded-md py-2 px-2"
                            value={t('pupil.lens-text')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PupilBehavior;
